import styled from "styled-components"
import {
  Content,
  Description,
  OverLay,
  StyledImage,
  SubTitle,
  Title,
  WelcomeOnboardingPage,
} from "./styled"
import banner from "assets/images/welcome-onboarding-bg.webp"
import Button from "components/Buttons/Button"
import { isInWebView } from "utils/webViewDetection"
import { Navigate, useNavigate } from "react-router-dom"
import PATHS from "router/paths"

const WelcomeOnboarding = () => {
  const navigate = useNavigate()

  if (!isInWebView()) {
    return <Navigate to={PATHS.app.personalInfo} />
  }

  return (
    <WelcomeOnboardingPage>
      <StyledImage src={banner} alt="Auth Banner" />
      <OverLay />
      <Content>
        <SubTitle>WELCOME TO</SubTitle>
        <Title>Food Journal</Title>
        <Description>Upgrade your tracking experience!</Description>
        <Description>
          Scan your meals and see how your diet impacts your body shape and
          composition over time. Quick setup required.
        </Description>

        <Button
          style={{ marginTop: "auto" }}
          $borderLess
          $type="primary"
          onClick={() => {
            navigate(PATHS.app.personalInfo)
          }}
        >
          Get Started
        </Button>
      </Content>
    </WelcomeOnboardingPage>
  )
}

export default WelcomeOnboarding
